import { CssBaseline } from "@mui/material";
// theme
import { ThemeProvider } from "@mui/material/styles";
import { IntlProvider } from "react-intl";
import { useQueueManager } from "@/modules/ticket/ticketQueue/useQueueManager";
import { useAppSelector } from "@/store/store";
import NotificationComponent from "../components/NotificationComponent";
import translations from "../i18n/locales";
import { propertyManagementSelectors } from "../modules/propertyManagement/propertyManagementSlice";
import getThemeById from "../themes/getThemeById";
import Routes from "./Routes.jsx";

// Note: react-intl v2 used addLocaleData and locale-data imports which rely on
// the legacy React context API. Modern react-intl versions no longer need
// addLocaleData; keep IntlProvider only and upgrade the package to remove the
// legacy-context warning.

function getLocaleByPropertyManagementId(id) {
  switch (id) {
    case 7: // Stage-Account martin-tml@hausify.de pausify
      return "de_custom_7";
    case 1631: // Getränkeland
      return "de_custom_1631";
    default:
      return "de";
  }
}

const App = () => {
  const propertyManagement = useAppSelector(
    propertyManagementSelectors.selectPropertyManagement,
  );

  const propertyManagementId = propertyManagement?.id || 0;

  // handle theme
  const theme = getThemeById(propertyManagementId);

  // use a custom language file or use de if there is no customization
  const localeKey = getLocaleByPropertyManagementId(propertyManagementId);
  const messages = translations[localeKey];

  const [locale] = localeKey.split("_");

  // handle ticket queue
  useQueueManager();

  return (
    <IntlProvider locale={locale} key={locale} messages={messages}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Routes />
        <NotificationComponent />
      </ThemeProvider>
    </IntlProvider>
  );
};

export default App;
